export enum DashboardType {
  EVENT_PERFORMANCE = 'event_performance',
  WEEKLY_ANALYSIS = 'weekly_analysis',
  ADVANCED_PERFORMANCE = 'advanced_performance',
  TRAINING_LOAD = 'training_load',
  INDIVIDUAL_PERFORMANCE = 'individual_performance',
}
